import { useEffect, useState } from 'react';
import { collection, query, where, onSnapshot } from 'firebase/firestore';
import { db } from '../firebase/config';

const millis = (v) => v?.toMillis?.() ?? 0;

// Firmaets egne ordre, sortert på planlagt tidspunkt (tidligst først). Lesetilgang krever admin eller dispatcher.
export function useCarrierOrders(orgId) {
  const [state, setState] = useState({ orders: [], loading: Boolean(orgId), error: false });

  useEffect(() => {
    if (!orgId) {
      setState({ orders: [], loading: false, error: false });
      return undefined;
    }
    return onSnapshot(
      query(collection(db, 'orders'), where('carrierOrgId', '==', orgId)),
      snap => setState({
        orders: snap.docs.map(d => ({ id: d.id, ...d.data() })).sort((a, b) => millis(a.scheduledAt) - millis(b.scheduledAt)),
        loading: false,
        error: false,
      }),
      () => setState({ orders: [], loading: false, error: true }),
    );
  }, [orgId]);

  return state;
}
